import { Model } from '@nozbe/watermelondb';

import { ValidationOperation } from '../db/validation/validator';

import {
    OptionalBoolean,
    OptionalString,
    RequiredUuid,
    UpdateRawRecord,
} from './rawRecordFields';

export enum EVENT_CONTACT_STATUS {
    AWAITING = 'awaiting',
    REJECTED = 'rejected',
    ACCEPTED = 'accepted',
}

export type EventContactModel = {
    eventId: string;
    contactId: string;
    userId: string;
    organisationId: string;
    sentSms: boolean;
    sentSmsAt: string;
    sentSmsStatus: string | null;
    sentEmail: boolean;
    sentEmailAt: string;
    status: EVENT_CONTACT_STATUS;
} & Model;

export type EventContactPayload = {
    eventId: string;
    contactId: string;
    userId: string;
    organisationId: string;
    sentSms: boolean;
    sentEmail: boolean;
    status: EVENT_CONTACT_STATUS;
};

export type EventContactSimple = {
    id: string;
    eventId: string;
    contactId: string;
    userId: string;
    organisationId: string;
    sentSms: boolean;
    sentSmsAt: string;
    sentSmsStatus: string;
    sentEmail: boolean;
    sentEmailAt: string;
    status: string;
    createdAt: string;
    updatedAt: string;
};

export type EventContactRawRecord = {
    id: string;
    created_at: number;
    updated_at: number;
    event_id: string;
    contact_id: string;
    user_id: RequiredUuid;
    organisation_id: RequiredUuid;
    sent_sms?: OptionalBoolean;
    sent_sms_at: string;
    sent_email?: OptionalBoolean;
    sent_email_at: string;
    status?: OptionalString;
};

export type EventContactUpdateRawRecord =
    UpdateRawRecord<EventContactRawRecord>;

export type EventContactEntityTableName = 'event_contacts';

export type RecordByEventContactEntityTable = {
    event_contacts: EventContactRawRecord;
};

export type ModelByEventContactEntityTable = {
    event_contacts: EventContactModel;
};

export type EventContactPreparedDataItem = {
    [K in EventContactEntityTableName]: {
        table: K;
        record: ModelByEventContactEntityTable[K];
        operation: ValidationOperation;
    };
}[EventContactEntityTableName];
